export type SnBrandLogoSize = 'xsm' | 'sm' | 'md' | 'lg';
